var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var getOperatorEscalationUrl = function (cardId, answers, selectionPath, karakuriWebRootUrl, operatorEscalationKeyword, session) {
    var parameters = selectionPath
        .filter(function (x) { return x !== cardId; })
        .map(function (x) {
        var selected = answers
            .filter(function (a) { var _a; return !!(((_a = a === null || a === void 0 ? void 0 : a.actions) === null || _a === void 0 ? void 0 : _a.actions) || []).some(function (action) { return (action === null || action === void 0 ? void 0 : action.id) === x; }); })
            .map(function (_) { return _.actions; })[0];
        if (!selected) {
            return null;
        }
        var selectedAction = ((selected === null || selected === void 0 ? void 0 : selected.actions) || []).find(function (action) { return (action === null || action === void 0 ? void 0 : action.id) === x; });
        return {
            action: selectedAction === null || selectedAction === void 0 ? void 0 : selectedAction.id,
            answer: selected.id,
            card: cardId,
            displayText: selectedAction === null || selectedAction === void 0 ? void 0 : selectedAction.label,
        };
    })
        .filter(function (x) { return !!x; });
    parameters = __spreadArray(__spreadArray(__spreadArray([], answers.filter(function (x) { return x.id === cardId; }).map(function (x) { return x.ask; }), true), parameters, true), [
        operatorEscalationKeyword,
    ], false);
    return "".concat(karakuriWebRootUrl, "/embed/?queries=").concat(encodeURIComponent(JSON.stringify(parameters))).concat(session.value ? "&session=".concat(encodeURIComponent(session.value)) : '');
};
//# sourceMappingURL=getOperatorEscalationUrl.js.map